<!--
통관안내문 컴포넌트
-->
<template>
    <div>
        [통관정보없음]건들의 개인통관고유부호를 확인하셔서 반드시 출고전에 입력해 주셔야 합니다.  입력방법: [통관정보없음] 버튼 클릭=> [배송정보] 페이지에서 수정가능

        <a class="uk-link-text uk-text-primary" @click="expanded = true" v-show="! expanded">
            <i class="material-icons">arrow_drop_down</i>
            일반통관안내
        </a>

        <div class="uk-margin-top" v-show="expanded">
            [일반통관]인 경우, 개인통관고유부호(또는 주민등록번호)가 있어야 통관 가능합니다.  생년월일로는 통관이 되지 않습니다.<br />
            일반통관 대상 : 총 결제액이 $150(미국 $200) 초과 또는 목록배제품목(건강식품류, 기능성화장품 등)인 경우

            <a class="uk-link-text uk-text-primary" @click="expanded = false" v-show="expanded">
                <i class="material-icons">arrow_drop_up</i>
                닫기
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data: function () {
            return {
                // (bool) 확장여부
                expanded: false,
            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
</style>